import React from "react";
import Header from "../components/Header/Header";
import Navbar from "../components/Navbar/Navbar";

const AboutThisImmunocon = () => {
  return (
    <div>
      <Header />
      <Navbar />
      <div className="max-w-7xl mx-auto p-8">
        <h2 className="text-3xl pb-2 mb-4 ">
          About the 52<sup className="-z-10">nd</sup> Immunocon
        </h2>
        <p className="text-gray-600 text-md md:text-lg leading-relaxed mb-4">
          Considering the challenges faced by human society in the last three
          years due to the COVID-19 pandemic, it is of significant importance to
          look for a converging point where{" "}
          <em className="italic">‘Immunology meets Technology.’</em> Being a
          premier institute of engineering and technology and an{" "}
          <em className="italic">Institute of National Importance</em> in India,
          MNNIT Allahabad is hosting the{" "}
          <strong className="font-semibold">
            52<sup>nd</sup> Immunocon in 2025.
          </strong>{" "}
          <em className="italic">Immunocon</em> has never been organized in
          Prayagraj, one of the education hubs in India's north, particularly in
          Uttar Pradesh. Institutes like the University of Allahabad (a central
          university), the Indian Institute of Information Technology Allahabad
          (IIIT Allahabad), Motilal Nehru Medical College, and several others
          are located in Prayagraj city.
        </p>
        <p className="text-gray-600 text-md md:text-lg leading-relaxed mb-4">
          The 52<sup>nd</sup> Immunocon will provide a platform to bridge a gap
          between immunology and technology, which is a need of the hour. Using
          sustainable technology may offer quicker ways to surveillance and map
          various diseases. Besides, this provides tools to monitor various
          read-outs or end-points of any experiment effectively. In a developing
          country like India, we need sustainable techniques and quality
          indigenous instruments to enrich our research, which may lead to new
          avenues. As the country celebrated its 75th year of independence as
          Amrut Mahotsav, it is the duty of ‘we immunologists’ to join hands
          with the technologists to strengthen an eco-system of{" "}
          <em className="italic">‘Immunotechnology’</em> in the country.
        </p>
        <div className="mt-6">
          <p className="text-gray-800 font-bold">
            Date:{" "}
            <span className="font-medium text-gray-700">
              November 19-22, 2025
            </span>
          </p>
          <p className="text-gray-800 font-bold mt-2">
            Theme of the conference:{" "}
            <span className="italic text-gray-700">
              ‘Immunology Meets Technology: Improving the Effectiveness and
              Reach of Immunotherapy’
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutThisImmunocon;
